module.exports = __webpack_public_path__ + "static/help-680525e27174fd084f20fba306c01017.mp4";